var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "canvas-container" },
    [
      _c("canvas", {
        ref: "unityCanvas",
        style: { background: _vm.background, opacity: _vm.canvasOpacity },
        attrs: { id: "unity-canvas" },
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }